"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.split");

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuexClass = require("vuex-class");

var _vuePropertyDecorator = require("vue-property-decorator");

var _elementUi = require("element-ui");

var _loading = require("@/mixins/loading/loading");

var _helper = require("@/mixins/helper/helper");

var _mapWorld = _interopRequireDefault(require("@/components/map-world/map-world.vue"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var MapComponent = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(MapComponent, _Mixins);

  var _super = _createSuper(MapComponent);

  function MapComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, MapComponent);
    _this = _super.apply(this, arguments);
    _this.locations = {};
    _this.truckData = [];
    _this.truckName = '';
    _this.containerNum = '';
    _this.gpsId = '';
    _this.initEvent = 'polylines';
    _this.selectedMarkers = [];
    return _this;
  }

  (0, _createClass2.default)(MapComponent, [{
    key: "created",
    value: function created() {
      this.loading = false;
      this.truckName = window.localStorage.getItem('tName') ? window.localStorage.getItem('tName') : null;
      this.containerNum = window.localStorage.getItem('tContainerNum') ? window.localStorage.getItem('tContainerNum') : null;
      this.gpsId = window.localStorage.getItem('tGpsId') ? window.localStorage.getItem('tGpsId') : null;
      this.locations = window.localStorage.getItem('tLocation') ? this.helper.toJson(window.localStorage.getItem('tLocation')) : {
        'latitude': this.helper.get(this.$userData, 'latlng', '0,0').split(',')[0],
        'longitude': this.helper.get(this.$userData, 'latlng', '0,0').split(',')[1]
      };
      this.truckData = window.localStorage.getItem('tData') ? this.helper.toJson(window.localStorage.getItem('tData')) : [];
      this.initEvent = window.localStorage.getItem('tInitEvent') ? window.localStorage.getItem('tInitEvent') : 'polylines';
    } // duplicated

  }, {
    key: "isChina",
    get: function get() {
      return this.$userSetting['default10'];
    }
  }]);
  return MapComponent;
}((0, _vuePropertyDecorator.Mixins)(_loading.LoadingMixin, _helper.HelperMixin));

(0, _tslib.__decorate)([(0, _vuexClass.Getter)('userSetting', {
  namespace: 'authentication'
})], MapComponent.prototype, "$userSetting", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('userData', {
  namespace: 'authentication'
})], MapComponent.prototype, "$userData", void 0);
MapComponent = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'MapComponent',
  components: {
    'map-world': _mapWorld.default,
    'el-tooltip': _elementUi.Tooltip
  }
})], MapComponent);
var _default = MapComponent;
exports.default = _default;